import { render, staticRenderFns } from "./servicesBanner.vue?vue&type=template&id=22b8c606&scoped=true"
import script from "./servicesBanner.vue?vue&type=script&lang=js"
export * from "./servicesBanner.vue?vue&type=script&lang=js"
import style0 from "./servicesBanner.vue?vue&type=style&index=0&id=22b8c606&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8c606",
  null
  
)

export default component.exports